import { format } from 'date-fns';
import de from 'date-fns/locale/de';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';

import { ArrowIcon } from '@/components/Icon';
import Text from '@/components/Text';

const HeaderListAppointment = ({ showAppointment, onReset, onToday }) => {
  const currDate = format(new Date(), 'dd. MMMM yyyy', { locale: de });
  return (
    <>
      <Flex
        justifyContent={showAppointment && showAppointment !== 'show-all' ? 'space-between' : 'center'}
        alignItems="center"
        backgroundColor="white"
      >
        {showAppointment && showAppointment !== 'show-all' && (
          <Flex alignItems="center" onClick={onReset} sx={{ cursor: 'pointer' }}>
            <Text variant="small" color="primary">
              <ArrowIcon style={{ transform: 'rotate(-90deg)' }} /> alle
            </Text>
          </Flex>
        )}

        <Text variant="tabTitle">
          {showAppointment === 'show-all'
            ? 'Nächste Ereignisse'
            : format(new Date(showAppointment), 'dd. MMMM yyyy', { locale: de })}
        </Text>

        {showAppointment && showAppointment !== 'show-all' && (
          <>
            {currDate !== format(new Date(showAppointment), 'dd. MMMM yyyy', { locale: de }) ? (
              <Box onClick={onToday} width="37px" sx={{ cursor: 'pointer' }}>
                <Text variant="small" color="primary">
                  heute
                </Text>
              </Box>
            ) : (
              <Box width="37px" />
            )}
          </>
        )}
      </Flex>
    </>
  );
};

HeaderListAppointment.propTypes = {
  onReset: PropTypes.string.isRequired,
  onToday: PropTypes.string.isRequired,
  showAppointment: PropTypes.string.isRequired,
};

export default HeaderListAppointment;
